document.addEventListener("DOMContentLoaded", () => {

  document.querySelectorAll(".bricq-accordion-item").forEach((item) => {

    const button = item.querySelector(".bricq-accordion-toggle");
    const content = item.querySelector(".bricq-accordion-content");
    const icon = item.querySelector(".bricq-accordion-icon");

    icon.textContent = "+";

    content.style.height = "0px";
    content.style.overflow = "hidden";

    button.addEventListener("click", (e) => {

      e.stopPropagation();

      const opened = item.classList.contains("active");



      if (opened) {

        content.style.height = content.scrollHeight + "px";

        requestAnimationFrame(() => {
          content.style.height = "0px";
        });

        item.classList.remove("active");
        icon.textContent = "+";


        
      } else {



        item.classList.add("active");

        content.style.height = content.scrollHeight + "px";

        icon.textContent = "−";

        content.addEventListener("transitionend", function handler() {

          if (item.classList.contains("active")) {
            content.style.height = "auto";
          }

          content.removeEventListener("transitionend", handler);

        });

      }

    });

  });

});